// extracted by mini-css-extract-plugin
module.exports = {"show-more":"index__show-more___W8lml"};